<div class="box custom-box h-full flex flex-col">
  <div class="box-header">
    <div class="box-title">Processos por Status</div>
  </div>
  <div class="box-body !p-0 flex-1 flex flex-col">
    <!-- Loading State -->
    <div *ngIf="loading" class="flex items-center justify-center p-8">
      <app-loading-spinner message="Carregando processos..."></app-loading-spinner>
    </div>

    <!-- Error State -->
    <div *ngIf="!loading && error" class="flex items-center justify-center p-8">
      <div class="text-center text-danger">
        <div class="flex items-center gap-2 mb-4">
          <i class="ri-error-warning-line text-xl"></i>
          <p class="!mt-1">Erro ao carregar dados dos processos</p>
        </div>
        <button class="ti-btn ti-btn-primary-full !py-1 !px-2 ti-btn-wave" (click)="loadProcessesByStatus()">
          <i class="ri-refresh-line"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <!-- Success State - Pie Chart -->
    <div *ngIf="!loading && !error && hasData" id="processes-by-status-chart" class="flex-1">
      <apx-chart [series]="chartOptions.series!" [chart]="chartOptions.chart!" [labels]="chartOptions.labels!"
        [colors]="chartOptions.colors!" [legend]="chartOptions.legend!" [dataLabels]="chartOptions.dataLabels!"
        [plotOptions]="chartOptions.plotOptions!" [tooltip]="chartOptions.tooltip!"></apx-chart>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && !error && !hasData" class="flex-1 flex items-center justify-center p-8">
      <div class="text-center text-gray-500">
        <i class="ri-pie-chart-line text-4xl mb-3 block"></i>
        <p class="font-semibold text-sm mb-1">Nenhum processo encontrado</p>
        <p class="text-xs">O gráfico será exibido quando houver processos cadastrados.</p>
      </div>
    </div>
  </div>
</div>